const routePaths = {
  HOME: '/',
  GENERATE: '/generate',
  ABOUT_PROJECT: '/about-project',
  GALLERY: '/gallery',
  STATISTICS: '/statistics',
}

export default routePaths
